import { isEmptyUserCustomAttributeValue } from 'shared-helpers/customAttributes';

import type { UserCustomAttributes } from 'shared-types';

interface Params {
  customAttributes: UserCustomAttributes;
  newCustomAttributes: UserCustomAttributes;
}

const updateUserCustomAttributes = ({
  customAttributes,
  newCustomAttributes
}: Params) => {
  const now = Date.now();

  // this object will be mutated and sent as output
  const userCustomAttributes: UserCustomAttributes = JSON.parse(
    JSON.stringify(customAttributes || {})
  );

  const changedKeys: string[] = [];
  Object.keys(newCustomAttributes || {}).forEach((key) => {
    const existingValue = customAttributes?.[key];
    let value = newCustomAttributes[key];
    if (typeof value === 'string') {
      value = value?.trim();
    } else if (Array.isArray(value)) {
      value = value?.map((item) =>
        typeof item === 'string' ? item?.trim() : item
      );
    }

    if (isEmptyUserCustomAttributeValue(value)) {
      if (!isEmptyUserCustomAttributeValue(existingValue)) {
        // custom attribute is being removed or set to null
        changedKeys.push(key);
      }
      delete userCustomAttributes[key];
      return;
    }

    // if there is a value but is the same as the original, exit
    if (JSON.stringify(value) === JSON.stringify(existingValue)) return;

    // update custom attribute
    changedKeys.push(key);
    userCustomAttributes[key] = JSON.parse(JSON.stringify(value));
    userCustomAttributes[`_${key}.edited`] = now;
  });

  return {
    changedKeys,
    customAttributesChanged: changedKeys.length > 0,
    userCustomAttributes
  };
};

export default updateUserCustomAttributes;
